<div class="hero-component">
    <h1>{{title}}</h1>
    <p class="text">{{description}}</p>
  </div>
  